import { useEditorStore } from '@/store/use-editor-store';
import { Shape, ShapeType } from '.';
import { uniqueName } from '@/utils/fs/name.utils';
import { shapeCnNameMap } from '@/hooks';
import { canUse } from '@/utils/can-use.utils';
import { round } from 'lodash-es';

export class ShapeUtils {
  static getCNName(type: ShapeType) {
    if (type == ShapeType.Sprite && canUse('shape-video').valid) {
      return '序列帧/视频1';
    }
    return shapeCnNameMap[type] ?? type;
  }

  static generateShapeName(type: ShapeType, parentShapeId?: string) {
    const basename = ShapeUtils.getCNName(type);
    const shapes = parentShapeId
      ? Shape.getShape(parentShapeId)?.children ?? []
      : Shape.shapeTree(useEditorStore().themeId, false);

    const names = shapes.map((item) => item.attrs.name ?? '');
    return uniqueName(names, basename);
  }

  /**
   * 获取shape文本宽度
   * @param text
   * @param options
   * @returns
   */
  static getActualSizeOfChars = async (
    text: string,
    options: { family?: string; fontSize?: number; letterSpacing?: number }
  ) => {
    const {
      fontSize = 14,
      family = 'Microsoft YaHei',
      letterSpacing = 0
    } = options;

    // await loadMisansFont(text, {
    //   family,
    //   emit: true
    // });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', {
      willReadFrequently: true
    });
    if (!ctx) return;
    ctx.canvas.style.letterSpacing = '90px';
    ctx.font = `${fontSize}px ${family}`;
    const metrics = ctx.measureText(text);

    const actual =
      Math.abs(metrics.actualBoundingBoxLeft) +
      Math.abs(metrics.actualBoundingBoxRight);

    // 当前文本字符串在这个字体下用的实际高度
    const width =
      Math.floor(Math.max(metrics.width, actual)) +
      (text.length - 1) * letterSpacing;
    const height = metrics.fontBoundingBoxAscent;

    return { width, height };
  };

  static toDataSourceType = (shape: Shape) => {
    switch (shape.type) {
      case ShapeType.Text:
        return 'text';
      case ShapeType.Image:
        return 'image';
      case ShapeType.ImageArray:
        return shape.attrs.fillType == '数字填充'
          ? 'image-array-digit'
          : 'image-array-normal';
      case ShapeType.ProgressBar:
        return 'progress-bar';
      default:
        return;
    }
  };

  static getPointerRadius(shape: Shape, small = false) {
    const { pivotX = 0, pivotY = 0, w = 0, h = 0 } = shape.attrs;
    if (small) {
      const r1 = pivotX;
      const r2 = w - pivotX;
      const r3 = pivotY;
      const r4 = h - pivotY;
      return round(Math.max(r1, r2, r3, r4), 0);
    }
    const r1 = Math.sqrt((w - pivotX) ** 2 + (h - pivotY) ** 2);
    const r2 = Math.sqrt((w - pivotX) ** 2 + pivotY ** 2);
    const r3 = Math.sqrt(pivotX ** 2 + pivotY ** 2);
    const r4 = Math.sqrt(pivotX ** 2 + (h - pivotY) ** 2);
    return round(Math.max(r1, r2, r3, r4), 2);
  }
}
